import angular from "angular";
import { CANCEL_INTAKE_MODAL_SERVICE, CancelIntakeService } from "./cancel-intake.service";

const CANCELINTAKE_MODAL_MODULE = "cancelIntakeModalService";

angular.module(CANCELINTAKE_MODAL_MODULE, [])
    .factory(CANCEL_INTAKE_MODAL_SERVICE, CancelIntakeService);

export { CANCELINTAKE_MODAL_MODULE, CANCEL_INTAKE_MODAL_SERVICE };
